import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FiChevronDown, FiHelpCircle } from 'react-icons/fi';
import './FAQ.css';

const faqs = [
  {
    q: "Combien coûte la location d'une limousine à Paris ?",
    a: "Le tarif d'une limousine avec chauffeur à Paris dépend du véhicule choisi, de la durée et du service. Nos forfaits horaires démarrent à partir de 250 € pour 2 heures avec une berline de luxe. Les limousines stretch (Hummer, Chrysler) sont à partir de 350 € pour 2 heures. Les transferts aéroport (Roissy CDG, Orly) sont en tarif forfaitaire à partir de 120 €. Devis personnalisé gratuit en moins d'une heure."
  },
  {
    q: "Quelles zones desservez-vous en Île-de-France ?",
    a: "VIP Limousine Paris dessert tout Paris (75) et l'ensemble de l'Île-de-France : Hauts-de-Seine (92), Seine-Saint-Denis (93), Val-de-Marne (94), Yvelines (78), Val-d'Oise (95), Essonne (91) et Seine-et-Marne (77). Nous desservons également les aéroports parisiens (Roissy CDG, Orly, Le Bourget, Beauvais), Disneyland Paris, le Château de Versailles et les principales villes voisines."
  },
  {
    q: "Combien de personnes peut accueillir une limousine ?",
    a: "Nos limousines stretch (Hummer H3, Chrysler 300) accueillent jusqu'à 8 à 10 passagers. La Rolls Royce Phantom accueille 4 à 5 passagers en grand confort. Pour les groupes plus importants, notre Mercedes V-Class est disponible jusqu'à 8 passagers avec configuration salon. Indiquez-nous votre nombre de passagers lors de la réservation pour vous proposer le véhicule idéal."
  },
  {
    q: "Comment réserver une limousine avec chauffeur ?",
    a: "La réservation est très simple : remplissez le formulaire de réservation sur la page d'accueil de notre site, et toutes les informations seront envoyées directement par WhatsApp à notre équipe. Vous pouvez aussi nous appeler ou nous écrire directement au 06 61 63 01 13. Réponse garantie en moins d'une heure 24h/24, 7j/7. Nous vous confirmons la disponibilité et le tarif sous quelques minutes."
  },
  {
    q: "Proposez-vous des limousines pour les mariages à Paris ?",
    a: "Oui, le mariage est notre spécialité. Nous proposons un service complet : décoration florale incluse, champagne offert, photoshoot privé devant les plus beaux monuments parisiens (Tour Eiffel, pont Alexandre III, Place Vendôme, pont de Bir-Hakeim), itinéraire personnalisé. Notre flotte de mariage comprend la Rolls Royce Phantom blanche, le Hummer stretch blanc et la Chrysler 300 stretch blanche."
  },
  {
    q: "Faites-vous les transferts aéroport (CDG, Orly) ?",
    a: "Oui, nous assurons les transferts VIP vers et depuis tous les aéroports parisiens : Roissy Charles de Gaulle (CDG), Orly, Le Bourget et Beauvais. Notre service inclut le suivi de vol en temps réel, l'accueil personnalisé avec panneau nominatif à l'arrivée, l'assistance bagages et un tarif forfaitaire fixe sans surprise. Service disponible 24h/24."
  },
  {
    q: "Quels véhicules sont disponibles dans votre flotte ?",
    a: "Notre flotte premium comprend : Rolls Royce Phantom blanche (ultra luxe), Hummer H3 stretch blanche (jusqu'à 8 passagers), Chrysler 300 stretch blanche (jusqu'à 8 passagers), Mercedes Classe S (berline de luxe), BMW Série 7 (berline executive), Mercedes V-Class (van de luxe). Tous les véhicules ont moins de 3 ans en moyenne et sont entretenus selon les plus hauts standards."
  },
  {
    q: "Êtes-vous disponibles 24h/24 et 7j/7 ?",
    a: "Oui, VIP Limousine Paris fonctionne 24 heures sur 24, 7 jours sur 7, y compris les jours fériés. Notre service d'urgence permet une réservation immédiate en cas de besoin. La nuit, le week-end et les jours fériés ne génèrent aucun surcoût pour les réservations standards."
  },
  {
    q: "Le chauffeur est-il inclus avec la location ?",
    a: "Oui, toutes nos limousines sont louées avec chauffeur professionnel. Nos chauffeurs sont en costume, formés au service VIP, expérimentés et parlent français et anglais. Ils sont garants de votre confort, de votre sécurité et du respect du planning. Un chauffeur dédié peut être attribué pour les missions longues ou les clients réguliers."
  },
  {
    q: "Quelles sont les options de paiement ?",
    a: "Nous acceptons les paiements par carte bancaire (Visa, Mastercard, American Express), virement bancaire et espèces. Un acompte de 30% est demandé à la réservation, le solde étant payable avant la prestation. Pour les entreprises, nous proposons une facturation mensuelle sur compte client."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? -1 : idx);
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(({ q, a }) => ({
      "@type": "Question",
      "name": q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": a
      }
    }))
  };

  return (
    <section className="faq section-padding" id="faq" itemScope itemType="https://schema.org/FAQPage">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <div className="container">
        <div className="section-header text-center">
          <span className="section-badge">
            <FiHelpCircle style={{ verticalAlign: 'middle', marginRight: 6 }} />
            Questions Fréquentes
          </span>
          <h2 className="section-title">
            Tout savoir sur la
            <span className="title-accent">location de limousine à Paris</span>
          </h2>
          <p className="section-description">
            Les réponses aux questions les plus fréquentes sur notre service de
            location de limousine avec chauffeur à Paris et en Île-de-France.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <article
                key={idx}
                className={`faq-item ${isOpen ? 'open' : ''}`}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <button
                  className="faq-question"
                  onClick={() => toggle(idx)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${idx}`}
                >
                  <h3 itemProp="name">{item.q}</h3>
                  <FiChevronDown className="faq-chevron" />
                </button>
                <div
                  id={`faq-answer-${idx}`}
                  className="faq-answer"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                  hidden={!isOpen}
                >
                  <p itemProp="text">{item.a}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
